module.exports = __webpack_public_path__ + "img/ça-m'est-égal.29507661.png";